<template>
  <div class="container-categorias">
    <div class="container-fade">
      <div class="categorias-header">
        <h2 class="categorias-title">{{ article.story.categorias.title }}</h2>
        <div class="excerpt">{{ article.story.categorias.excerpt }}</div>
        <ul class="submenu-categorias">
          <li>
            <router-link :to="{name: 'miunivisionarios'}" custom v-slot="{ navigate, href }">
              <a :href="href" @click="countLink(`mi_univisionario`, 'miunivisionarios')">MI UNIVISIONARIO</a>
            </router-link>
          </li>
           <li>
            <router-link :to="{name: 'maestros'}" custom v-slot="{ navigate, href }">
              <a :href="href" @click="countLink(`maestros`,'maestros')">Maestros</a>
            </router-link>
          </li>
          <li>
            <router-link :to="{name: 'pioneros'}" custom v-slot="{ navigate, href }">
              <a :href="href" @click="countLink(`pioneros`,'pioneros')">Pioneros</a>
            </router-link>
          </li>
          <li>
            <router-link :to="{name: 'emprendedor'}" custom v-slot="{ navigate, href }">
              <a :href="href" @click="countLink(`emprendedores`,'emprendedor')">Emprendedores</a>
            </router-link>
          </li>
          <li>
            <router-link :to="{name: 'innovadores'}" custom v-slot="{ navigate, href }">
              <a :href="href" @click="countLink(`innovadores`,'innovadores')">Innovadores</a>
            </router-link>
          </li>
          <li>
            <router-link :to="{name: 'iconos'}" custom v-slot="{ navigate, href }">
              <a class="link-nav-univ" id="iconos-nav" :href="href" @click="countLink(`topnav-iconos`, 'iconos')">Íconos</a>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<style lang="scss">

  .categorias-header {
    display: block;
    width: 100%;
    max-width: 1220px;
    margin: 0 auto;
    text-align: center;
    color: #fff;
  }

  .categorias-title {
    font-family: "AkiraExpandedSuperBold";
  }

  .excerpt {
    max-width: 720px;
    margin: 25px auto;
    text-align: left;
  }

  .submenu-categorias {
    margin: 0;
    padding: 0;

    li {
      display: inline-block;
      margin: 0 15px;
      font-family: "TuskerGroteskBold";
      letter-spacing: 1px;
      text-transform: uppercase;

      a {
        font-size: 41px;
        color: #fff;

        &.router-link-active {
          border-bottom: solid 2px #ae9269;
        }
        
        &:hover {
          border-bottom: solid 2px #ae9269;
        }
      }
    }
  }

</style>

<script>

export default {
  name: 'Categorias',
  methods: {
    countLink(link, name) {
      window.dataLayer.push({
        event: "categorias_click",
        event_action: `categoriasnav-${link}`
      })

      if(document.getElementById(name)) {
        const top = document.getElementById(name).offsetTop
        document.getElementById(name).classList.add('active')
        window.scrollTo(0, top)
      }
    },
  },
  computed: {
    article() {
      return require(`@/i18n/es.json`)
    }
  }
}
</script>
